import { escapeSql } from '@rdrive/helper-sql';
import { makeChartConfig } from '@rdrive/helper-chart-config';

// Issue distribution by responsible party (the "BI-Responsible-Party" tag), for
// @rdrive/plugin-chart-donut's BaseDonutChart (IA_ABSORPTION_PLAN Phase 4 step 12b; was
// components/charts/ResponsiblePartyDonutChart.vue, whose query strings these are — the filter
// query now escapeSql()s its value, rule 6: an apostrophe broke it). Rendered `bare` in the
// Analysis page's Responsible Party / Assigned Team card.
export function useResponsiblePartyDonutChart({ chartName, filterContext, conn }) {
  const { rows: run, applyFilter, removeFilter } = makeChartConfig({ chartName, filterContext, conn });

  // Rows for the donut: { teamId, name, value } — `teamId` is the slice key the base hashes for the
  // colour and hands back to setResponsiblePartyFilter; here it is the responsible party itself.
  // `filteredIssues` exposes the tag as `responsibleParty` (a typed NULL when the column is absent).
  const getResponsiblePartyDistribution = async () => {
    const rows = await run(`
    SELECT 
      responsibleParty,
      COUNT(*) AS value
    FROM filteredIssues
    WHERE responsibleParty IS NOT NULL AND responsibleParty != ''
    GROUP BY responsibleParty
    ORDER BY value DESC
  `);

    return rows.map((row) => ({
      teamId: row.responsibleParty,
      name: row.responsibleParty || 'Unknown Responsible Party',
      value: Number(row.value),
    }));
  };

  // null clears this chart's filter registration
  const setResponsiblePartyFilter = async (responsibleParty) => {
    if (!responsibleParty) {
      await removeFilter();
      return;
    }
    await applyFilter(`
      SELECT DISTINCT id
      FROM issues
      WHERE "BI-Responsible-Party" = '${escapeSql(responsibleParty)}'
    `);
  };

  return { getResponsiblePartyDistribution, setResponsiblePartyFilter };
}
